{
  "metadata": {
    "id": "amoled-dark",
    "name": "Amoled",
    "description": "Портировано из темы «AMOLED» (dark)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "dark",
    "tags": [
      "dark",
      "ported"
    ],
    "source": {
      "file": "amoled.json",
      "project": "opencode",
      "url": "https://github.com/anomalyco/opencode",
      "upstreamFile": "packages/ui/src/theme/themes/amoled.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 21.0,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.472,
      "paletteMaxS": 0.526,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 4.4,
      "surfacesTarget": 4.0,
      "surfacesRaisedTarget": 5.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 21.8,
      "syntaxVsTextMinDeltaE": 22.7,
      "chartsMinDeltaE": 63.5,
      "textSeparationDeltaE": 31.9,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [],
      "modeLabel": "dark",
      "modeFromLuminance": "dark",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#b388ff",
      "hover": "#bc96ff",
      "active": "#c2a0ff",
      "foreground": "#000000",
      "muted": "#b388ff80",
      "emphasis": "#b388ff"
    },
    "surface": {
      "background": "#000000",
      "foreground": "#ffffff",
      "muted": "#1e1e1e",
      "mutedForeground": "#a6a6a6",
      "elevated": "#272727",
      "elevatedForeground": "#ffffff",
      "raised": "#434343",
      "raisedForeground": "#ffffff",
      "overlay": "#000000cc",
      "subtle": "#121212"
    },
    "interactive": {
      "border": "#464646",
      "borderHover": "#474747",
      "borderFocus": "#b388ff",
      "selection": "#ffffff29",
      "selectionForeground": "#ffffff",
      "focus": "#b388ff59",
      "focusRing": "#b388ff61",
      "cursor": "#ffffff",
      "hover": "#ffffff1c",
      "active": "#ffffff29"
    },
    "status": {
      "error": "#ff1744",
      "errorForeground": "#000000",
      "errorBackground": "#ff174424",
      "errorBorder": "#ff174473",
      "warning": "#ffea00",
      "warningForeground": "#000000",
      "warningBackground": "#ffea0024",
      "warningBorder": "#ffea0073",
      "success": "#00ff88",
      "successForeground": "#000000",
      "successBackground": "#00ff8824",
      "successBorder": "#00ff8873",
      "info": "#18ffff",
      "infoForeground": "#000000",
      "infoBackground": "#18ffff24",
      "infoBorder": "#18ffff73"
    },
    "pr": {
      "open": "#00ff88",
      "draft": "#a6a6a6",
      "blocked": "#ffea00",
      "merged": "#ff4081",
      "closed": "#ff1744"
    },
    "syntax": {
      "base": {
        "background": "#292929",
        "foreground": "#ffffff",
        "comment": "#909090",
        "keyword": "#ff00ff",
        "string": "#00ff88",
        "number": "#b388ff",
        "function": "#ffea00",
        "variable": "#ffffff",
        "type": "#ff6a00",
        "operator": "#cccccc"
      },
      "tokens": {
        "commentDoc": "#909090",
        "stringEscape": "#cccccc",
        "keywordImport": "#ff00ff",
        "storageModifier": "#ff00ff",
        "functionCall": "#ffea00",
        "method": "#ffea00",
        "variableProperty": "#ffea00",
        "variableOther": "#ffffff",
        "variableGlobal": "#b388ff",
        "variableLocal": "#cccccc",
        "parameter": "#ffffff",
        "constant": "#b388ff",
        "class": "#ff6a00",
        "className": "#ff6a00",
        "interface": "#ff6a00",
        "struct": "#ff6a00",
        "enum": "#ff6a00",
        "typeParameter": "#ff6a00",
        "namespace": "#ff6a00",
        "module": "#ff00ff",
        "tag": "#ff00ff",
        "jsxTag": "#ff00ff",
        "tagAttribute": "#ffea00",
        "tagAttributeValue": "#00ff88",
        "boolean": "#b388ff",
        "decorator": "#ff00ff",
        "label": "#ffea00",
        "regexp": "#00ff88"
      }
    },
    "charts": {
      "series": [
        "#b388ff",
        "#18ffff",
        "#00ff88",
        "#ffea00",
        "#ff1744"
      ]
    },
    "chat": {
      "background": "#000000",
      "userMessage": "#ffffff",
      "userMessageBackground": "#272727",
      "assistantMessage": "#ffffff",
      "assistantMessageBackground": "#1e1e1e",
      "timestamp": "#a6a6a6",
      "divider": "#464646",
      "typing": "#a6a6a6"
    },
    "loading": {
      "spinner": "#b388ff",
      "spinnerTrack": "#1e1e1e",
      "skeleton": "#1e1e1e",
      "shimmer": "#363636"
    },
    "tools": {
      "background": "#1e1e1e",
      "border": "#464646",
      "headerHover": "#343434",
      "icon": "#b388ff",
      "title": "#ffffff",
      "description": "#a6a6a6",
      "edit": {
        "added": "#00ff88",
        "addedBackground": "#00ff8824",
        "removed": "#ff1744",
        "removedBackground": "#ff174424",
        "modified": "#18ffff",
        "modifiedBackground": "#18ffff24",
        "lineNumber": "#a6a6a6"
      }
    },
    "markdown": {
      "heading1": "#ffffff",
      "heading2": "#ffffff",
      "heading3": "#ffffff",
      "heading4": "#ffffff",
      "link": "#b388ff",
      "linkHover": "#bc96ff",
      "inlineCode": "#00ff88",
      "inlineCodeBackground": "#1e1e1e",
      "blockquote": "#a6a6a6",
      "blockquoteBorder": "#464646",
      "listMarker": "#b388ffbf",
      "bold": "#ffffff",
      "italic": "#ffffffe6",
      "strikethrough": "#a6a6a6",
      "hr": "#464646"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#c96373",
        "foreground": "#000000",
        "contrast": 5.52
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#dcbfa9",
        "foreground": "#000000",
        "contrast": 12.07
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#cd9b68",
        "foreground": "#000000",
        "contrast": 8.48
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#dbe4a8",
        "foreground": "#000000",
        "contrast": 15.67
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#acd16e",
        "foreground": "#000000",
        "contrast": 12.1
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#6dcf70",
        "foreground": "#000000",
        "contrast": 10.81
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#92dc9f",
        "foreground": "#000000",
        "contrast": 12.96
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#73c7b0",
        "foreground": "#000000",
        "contrast": 10.53
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#abd8dd",
        "foreground": "#000000",
        "contrast": 13.6
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#69afcc",
        "foreground": "#000000",
        "contrast": 8.6
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#6986c0",
        "foreground": "#000000",
        "contrast": 5.77
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#5c60c4",
        "foreground": "#ffffff",
        "contrast": 5.35
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#a663c8",
        "foreground": "#000000",
        "contrast": 5.24
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#cea7da",
        "foreground": "#000000",
        "contrast": 10.16
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#ca64a4",
        "foreground": "#000000",
        "contrast": 5.87
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#dea2af",
        "foreground": "#000000",
        "contrast": 9.89
      }
    ]
  }
}
